import { render, staticRenderFns } from "./DeliveryMenuChannelPricePanel.vue?vue&type=template&id=21c5e896&scoped=true"
import script from "./DeliveryMenuChannelPricePanel.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuChannelPricePanel.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuChannelPricePanel.vue?vue&type=style&index=0&id=21c5e896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c5e896",
  null
  
)

export default component.exports